import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/PublicLayout";
import { Crumbs } from "@/components/content/ContentBits";
import { useContent } from "@/content/store";

const CORE = [["/", "Home"], ["/founding", "Founding members"], ["/tools", "Free Etsy tools"], ["/blog", "Guides"], ["/etsy-tags", "Etsy Tags"], ["/about", "About"],
  ["/policies/terms", "Terms of Service"], ["/policies/privacy", "Privacy Policy"], ["/policies/refund", "Refund Policy"], ["/policies/cookie", "Cookie Policy"]];

const Group = ({ title, items, testid }) => (
  <section data-testid={testid} className="mt-12">
    <h2 className="font-display text-2xl">{title}</h2>
    <ul className="mt-4 grid gap-x-8 gap-y-2 text-sm sm:grid-cols-2 lg:grid-cols-3">
      {items.map(([to, label]) => <li key={to}><Link to={to} className="text-muted-foreground underline-offset-4 hover:text-foreground hover:underline">{label}</Link></li>)}
    </ul>
  </section>
);

export default function HtmlSitemap() {
  const data = useContent("/content", true);
  const items = data?.items || [];
  return (
    <PublicLayout>
      <div data-testid="html-sitemap" className="mx-auto max-w-5xl px-5 py-10 sm:px-8 sm:py-14">
        <Crumbs testid="sitemap-breadcrumbs" items={[["Home", "/"], ["Sitemap"]]} />
        <h1 className="font-display text-4xl sm:text-5xl">Sitemap</h1>
        <Group title="Pages" testid="sitemap-core" items={CORE.map(([to, l]) => [to, l])} />
        <Group title="Free tools" testid="sitemap-tools" items={items.filter((a) => a.type === "tool").map((a) => [a.path, a.h1])} />
        <Group title="Guides" testid="sitemap-guides" items={items.filter((a) => a.type === "guide").map((a) => [a.path, a.h1])} />
        <Group title="Etsy tags by product" testid="sitemap-tags" items={items.filter((a) => a.type === "tags").map((a) => [a.path, `Etsy Tags for ${a.product}`])} />
      </div>
    </PublicLayout>
  );
}
